import { useCallback, useState } from 'react'
import { Alert, Button, Drawer, Empty, Typography } from 'antd'
import { SettingOutlined } from '@ant-design/icons'
import type { useConfiguration } from '../hooks/useConfiguration'
import type { DefinitionView } from '../config/definitions'
import { Icon, IconPicker } from './Icon'

const SETTINGS = <SettingOutlined aria-hidden />
const LABELS = { skill: '技能', capability: '能力' }
const ISSUE_TITLES = { unknown: '应用结果待确认，请重试确认', conflict: '配置已变化', failure: '配置应用失败' }
const Definition = ({ item, model }: { item: DefinitionView; model: ReturnType<typeof useConfiguration> }) => {
  const { editIcon, saving } = model
  const change = useCallback((iconKey: string | undefined) => {
    editIcon({ kind: 'definition_icon', target: item.target, id: item.id, iconKey: iconKey ?? '' })
  }, [editIcon, item.id, item.target])
  const id = item.target + '-icon-' + item.id
  return <div className="instance-administration__definition-icon-row"><label htmlFor={id}>
    <Icon iconKey={item.iconKey} fallback="appstore" /><span>{item.label || item.id}<small>{LABELS[item.target]}</small></span>
  </label><IconPicker id={id} value={item.iconKey} onChange={change} disabled={saving} /></div>
}

export const DefinitionIcons = ({ model }: { model: ReturnType<typeof useConfiguration> }) => {
  const [open, setOpen] = useState(false)
  const show = useCallback(() => setOpen(true), [])
  const close = useCallback(() => setOpen(false), [])
  const { saveDefinitions } = model
  const save = useCallback(() => { void saveDefinitions().catch(() => undefined) }, [saveDefinitions])
  const footer = <Button type="primary" onClick={save} disabled={!model.definitionChanged || !!model.readError
    || !!model.definitions.error || model.definitionIssue?.kind === 'conflict'} loading={model.saving}>
    {model.definitionIssue?.kind === 'unknown' ? '重试确认' : '保存并应用'}</Button>
  return <div className="instance-administration__definition-settings">
    <Button icon={SETTINGS} onClick={show}>图标设置</Button>
    <Drawer title="图标设置" open={open} onClose={close} footer={footer} size={520}>
      {model.definitions.error ? <Alert type="error" title={model.definitions.error} showIcon role="alert" /> : null}
      {model.definitionIssue ? <Alert type="error" title={ISSUE_TITLES[model.definitionIssue.kind]}
        description={model.definitionIssue.message} showIcon role="alert" /> : null}
      {model.definitions.entries.map((item) => <Definition key={item.target + ':' + item.id} item={item} model={model} />)}
      {!model.definitions.entries.length ? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暂无图标配置" /> : null}
      {model.definitionChanged ? <Typography.Text type="secondary">有未保存修改</Typography.Text> : null}
    </Drawer>
  </div>
}
